import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MoreRoutingModule } from './more-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, MoreRoutingModule],
  providers: []
})
export class MoreModule {}
